export default "__VITE_ASSET__JtvfsaiI__"